import joinPath from 'path.join'
import URI from 'urijs/src/URITemplate'

export function createLink(template, { link, ...options } = {}) {
  if (!link) {
    return new URI(joinPath('api', 'v1', template)).expand(options)
  }
  return link
}
